import React from 'react';
import ReactDom from 'react-dom';
import store from '@core/store';
import { Provider } from 'react-redux';

import Notification, { NotificationControl, NotificationData } from './Notification';
import { tealium } from '@utils/tealium.utils';
import { getModalDescription, getModalTypeDesc } from '@utils/notification.utils';

const rootId = 'notification-modal-overlay';

const showNotificationModal = (data: NotificationData, actions: NotificationControl[]): Promise<void> => {
  tealium.link({
    Event_Label: getModalDescription(data),
    ga_event: getModalTypeDesc(data.type)
  });

  return new Promise((resolve, reject) => {
    const el = document.getElementById(rootId) || createRootDomNode();
    ReactDom.render(
      <Provider store={store}>
        <Notification
          data={data}
          actions={actions}
          onSuccess={() => unmount(resolve)}
          onError={() => unmount(reject)}
        />
      </Provider>,
      el
    );
  });
};

const createRootDomNode = () => {
  const el = document.createElement('div');
  el.id = rootId;
  document.body.append(el);
  return el;
};

const unmount = (finish: () => void) => {
  const el = document.getElementById(rootId);
  ReactDom.unmountComponentAtNode(el);
  finish();
};

export default showNotificationModal;
